<script type="text/ecmascript-6">
    import DoorConfigurator from "./DoorConfigurator.vue";

    export default {
        mixins: [
            DoorConfigurator
        ],
        methods: {
            defaults() {
              return {
                6: {
                  "attr": {
                    "notes": "",
                    "door_range": 6,
                    "door_core": ["54mm", "solid"],
                    "fabricator": 3,
                    "frame_colour_external": 1,
                    "frame_material": 1,
                    "door_colour_internal": 77,
                    "external_colour": 77,
                    "frame_colour_internal": 1,
                    "glass_design": 1,
                    "glass_text": "",
                    "hardware_colour": 22,
                    "hardware_handle": 1442,
                    "hardware_hinge": 9,
                    "hinge_side": 1,
                    "opening_direction": 1,
                    "secured_by_design": 1,
                    "slab": 45,
                    "frame_style": {"frame_id": 1, "checkedPanels": []},
                    "laminated_glass": 1,
                    "hardware_lock": 237,
                    "hardware_cylinder": 1319,
                    "hardware_security_chain": 317,
                    "hardware_letterbox": 318,
                    "hardware_knocker": 315,
                    "hardware_spy_hole": 316,
                    "profile": 151,
                    "threshold": 232,
                    "side_panels": {
                      "left_composite_id": 130,
                      "right_composite_id": 130,
                      "left": 1,
                      "right": 1,
                      "left_panel_glass_id": 9,
                      "right_panel_glass_id": 9,
                      "top_panel_glass_id": 9,
                      "left_composite_glass_id": 1,
                      "right_composite_glass_id": 1,
                      "right_flag_sill_id": 149,
                      "left_flag_sill_id": 149
                    },
                    "numerals": [326, 326, 326, 326],
                    "cill": 149,
                      "addons": {
                          "left": {},
                          "right": {},
                          "top": {},
                          "bottom": {},
                      },
                    "drainage": 1,
                    "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                    "hardware_handle_split_spindle": 424,
                    "door_drip_colour": 77
                  }
                },
                7: {
                  "attr": {
                    "notes": "",
                    "door_range": 7,
                    "door_core": ["54mm", "solid"],
                    "fabricator": 3,
                    "frame_colour_external": 1,
                    "frame_material": 1,
                    "door_colour_internal": 77,
                    "external_colour": 77,
                    "frame_colour_internal": 1,
                    "glass_design": 1,
                    "glass_text": "",
                    "hardware_colour": 22,
                    "hardware_handle": 1442,
                    "hardware_hinge": 9,
                    "hinge_side": 1,
                    "opening_direction": 1,
                    "secured_by_design": 1,
                    "slab": 45,
                    "frame_style": {"frame_id": 1, "checkedPanels": []},
                    "laminated_glass": 1,
                    "hardware_lock": 237,
                    "hardware_cylinder": 1319,
                    "hardware_security_chain": 317,
                    "hardware_letterbox": 318,
                    "hardware_knocker": 315,
                    "hardware_spy_hole": 316,
                    "profile": 151,
                    "threshold": 232,
                    "side_panels": {
                      "left_composite_id": 130,
                      "right_composite_id": 130,
                      "left": 1,
                      "right": 1,
                      "left_panel_glass_id": 9,
                      "right_panel_glass_id": 9,
                      "top_panel_glass_id": 9,
                      "left_composite_glass_id": 1,
                      "right_composite_glass_id": 1,
                      "right_flag_sill_id": 149,
                      "left_flag_sill_id": 149
                    },
                    "numerals": [326, 326, 326, 326],
                    "cill": 149,
                      "addons": {
                          "left": {},
                          "right": {},
                          "top": {},
                          "bottom": {},
                      },
                    "drainage": 1,
                    "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                    "hardware_handle_split_spindle": 424,
                    "door_drip_colour": 77
                  }
                },
              };
            },
        }
    }
</script>
